import { addEventListener } from 'js-utils/src/event';

import init from '../../common/base/init';

init(() => {
  const toggles = document.querySelectorAll('.user-settings__section .-toggle');
  if(!toggles.length) return;

  addEventListener(toggles, 'click', (e) => {
    e.preventDefault();
    const toggle = e.currentTarget;
    const section = toggle.closest('.user-settings__section');
    section.classList.toggle('--expanded');
  });
});
